const moduleMyCars = {
    namespaced: true,
    state () {
        return {
            cars: JSON.parse(localStorage.getItem('tesbros_customer_cars')) || []
        }
    },
    getters: {
        cars(state) {
            return state.cars
        },
        active(state) {
            if(state.cars.length > 0) {
                return state.cars.find(car => car.active === true);
            }
        }
    },
    mutations: {
        ADD_CAR(state, payload) {
            state.cars.forEach((car) => {
                car.active = false;
            });
          console.log(payload);
            state.cars.push(payload.car);
        },
        CHANGE_CAR(state, payload) {
            state.cars.forEach((car) => {
                car.active = false;
            });
            state.cars[payload.index].active = true;
        },
        UPDATE_CAR(state, payload) {
            state.cars.forEach((car) => {
                car.active = false;
            });
            state.cars[payload.index] = payload.car;
        },
        LOAD_CARS(state, payload) {
            state.cars = payload.cars;
        },
        REMOVE_CAR(state, payload) {
            const wasActive = state.cars[payload.index].active || false;
            state.cars.splice(payload.index, 1);
            if(wasActive && state.cars.length > 0) {
                state.cars.forEach((car) => {
                    car.active = false;
                });
                state.cars[0].active = true;
            }
        },
        CLEAR_CARS(state) {
            state.cars = []
        },
        SAVE_CARS(state) {
            const parsed = JSON.stringify(state.cars);
            localStorage.setItem('tesbros_customer_cars', parsed);
          console.log(state);
        }
    },
    actions: {
       async saveCustomerCars({ state }) {
           if(customer_info.id == "") 
             return true;
         
            const apiUrl = "https://phpstack-747822-4845361.cloudwaysapps.com/api/update-customer-meta";
            const customerId = customer_info.id; // Replace with actual customer ID
            const metaId = ""; // Replace with actual metafield ID  
            const metaData = JSON.parse(localStorage.getItem('tesbros_customer_cars'));
            const requestBody = {
                customerId: customerId,
                metaData: metaData,
                metaId: metaId
            };

            try {
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(requestBody)
                });

                const result = await response.json();
                console.log("Metafield Update Response:", result);
            } catch (error) {
                console.error("Error updating customer metafield:", error);
            }
        },
        clear(garage) {
            garage.commit('CLEAR_CARS')
            garage.commit('SAVE_CARS')
        },
        add(garage, item) {
            if(item) {
                garage.commit('ADD_CAR', item)
                garage.commit('SAVE_CARS')
                garage.dispatch('saveCustomerCars');
            }
        },
        change(garage, data) {
            garage.commit('CHANGE_CAR', data)
            garage.commit('SAVE_CARS')
          garage.dispatch('saveCustomerCars');
        },
        update(garage, data) {
            garage.commit('UPDATE_CAR', data)
            garage.commit('SAVE_CARS')
          garage.dispatch('saveCustomerCars');
        },
        load(garage, items) {
            if(items) {
                garage.commit('LOAD_CARS', items)
                garage.commit('SAVE_CARS')
            }
        },
        remove(garage, item) {
            if(item) {
                garage.commit('REMOVE_CAR', item)
                garage.commit('SAVE_CARS')
            }
        },
    }
}
const moduleBundles = {
    namespaced: true,
    state () {
        return {
            items: []
        }
    },
    getters: {
        items(state) {
            return state.items
        }
    },
    mutations: {
        SET(state, payload) {
            state.items = payload.items;
        },
    },
    actions: {
        set(message, data) {
            message.commit('SET', data)
        },
    }
}
const store = Vuex.createStore({
    modules: {
        garage: moduleMyCars,
        bundles: moduleBundles
    }
})
const tesbrosPlugin = {
    install(app, options) {
        app.config.globalProperties.decodeEntity = (input) => {
            let textarea = document.createElement("textarea");
            textarea.innerHTML = input;
            return textarea.value;
        };
        app.config.globalProperties.cloneObject = (o) => {
            return JSON.parse(JSON.stringify(o));
        }
        app.config.globalProperties.formatCurrency = (amount) => {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
            }).format(amount/100);
        };
        app.config.globalProperties.formatCurrencyWithoutTrailingZeros = (amount) => {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 0
            }).format(amount/100);
        };
        app.config.globalProperties.capitalize = (text) => {
            return text.toLowerCase()
                .split(' ')
                .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                .join(' ');
        };
    }
}
